import {get} from '@/context/context';
import {AuthService} from "@/services/AuthService";
import {UserResponse} from "@/models/User/UserResponse";
import {UserRegisterResponse} from "@/models/User/UserRegisterResponse";
import {Servers} from "@/serverConfig";

export default (app: any) => {
    const {next} = app;

    const authService: AuthService = get('authService');
    const userAuth: UserResponse | UserRegisterResponse |'' = authService.getUserAuth();

    if (userAuth) {
        return next({
            path: '/',
        });
    }

    return next();
};
